import React, { Fragment, useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Dialog, DialogContent, DialogTitle } from "@material-ui/core";

import {
  hideLoader as stopLoader,
  showLoader as startLoader,
} from "../../../../../store/actions";
import {
  hideLoader,
  showLoader,
} from "../../../../../store/actions/loaderUtil";
import {
  clearNewSubscriberData,
  getFatcaDetails,
  getPreview,
  getSchemeDetails,
  getShortUrl,
  sendEmail,
  sendMail,
  sendMobileLink,
} from "../../../../../store/actions/newSubscriber";
import Signbutton from "../../../../forms/button";
import Image from "../../../../Image";
import { useNewSubscriberContext } from "../../Context/NewSubsciberContext";
import {
  setSummaryDetails,
  setFatcaDetails,
} from "../../Context/NewSubscriberAction";
import generateUrl from "../util/generateUrl";
import { AmountDetailsSummary } from "./AmountDetails";
import BankDetailsPreview from "./BankDetails";
import KycDetailsPreview from "./KycDetails";
import NomineeDetailsPreview from "./NomineeDetails";
import PersonalDetailsPreview from "./PersonalDetails";
import SchemeDetailsPreview from "./SchemeDetails";
import UploadedDocuments from "./UploadedDocuments";
import { SUCCESS_RESPONSE_CODE } from "..";

const IS_UAT = process.env.PUBLIC_URL === "/dit_uat_portal";

const BASE_URL = IS_UAT
  ? "https://clientwebsitesuat2.kfintech.com"
  : "https://mfs.kfintech.com";

const SubscriberSummary = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const {
    ackNumber: AckNumber,
    personalDetails: personalDetailsData,
    dispatch: dispatchContext,
    kycDetails,
  } = useNewSubscriberContext();

  const [displaySummary, setDisplaySummary] = useState(false);
  const [url, setUrl] = useState("");
  const [open, setOpen] = useState(false);
  const [openCopy, setOpenCopy] = useState(false);

  const agentId = useSelector((state) => state.authReducer.token).replace(
    "ARN-",
    ""
  );
  const { profileData = {} } = useSelector((state) => state.profileReducer);
  const { Distributor_Name = "" } = profileData;

  useEffect(() => {
    const fetchPreview = async () => {
      try {
        dispatch(startLoader());
        await dispatch(getSchemeDetails({ AckNumber }));
        const responseF = await dispatch(getFatcaDetails({ AckNumber }));
        if (Number(responseF?.statusCode) === SUCCESS_RESPONSE_CODE) {
          dispatchContext(setFatcaDetails(responseF));
        }
        const response = await dispatch(getPreview({ AckNumber }));
        if (Number(response?.statusCode) === SUCCESS_RESPONSE_CODE) {
          dispatchContext(setSummaryDetails(response));
          setDisplaySummary(true);
          // const { data } = response;
          // const { objPhotosigDetails } = data;
          // setImageDetails(objPhotosigDetails[0] || {});
        } else {
          throw new Error(response.message || "Something went wrong");
        }
      } catch (error) {
        console.log(error);
        alert(error);
      } finally {
        dispatch(stopLoader());
      }
    };

    fetchPreview();
  }, [dispatch, AckNumber]);

  const copyUrl = () => {
    navigator.clipboard.writeText(url);
    setOpenCopy(true);
    // alert("URL copied to clipboard");
  };
  const closeModal = () => {
    dispatch(clearNewSubscriberData());
    history.push("/");
  };

  const submit = async () => {
    try {
      dispatch(showLoader());
      // const link = generateUrl({
      //   AckNumber,
      //   agentId,
      // });
      // setUrl(link);

      // const link = `http://localhost:3001?AckNumber=${AckNumber}&agentId=${agentId}`;
      const link = `${BASE_URL}/dit-nps-transaction-confirmation?AckNumber=${AckNumber}&agentId=${agentId}&agentName=${Distributor_Name}`;

      const responseUrl = await dispatch(getShortUrl({ link }));
      if (+responseUrl?.statusCode === SUCCESS_RESPONSE_CODE) {
        setUrl(responseUrl?.data?.tinyUrl || link);
        const paramsMobile = {
          link: responseUrl?.data?.tinyUrl || link,
          AckNumber,
        };
        const res = await dispatch(sendMobileLink(paramsMobile));
        const params = {
          name: personalDetailsData?.data?.Name,
          agentName: Distributor_Name,
          link: responseUrl?.data?.tinyUrl,
          emailAddress: personalDetailsData?.data?.Email,
        };
        await dispatch(sendEmail(params));
        setOpen(true);
      }
    } catch (error) {
      alert(error);
      console.error(error);
    } finally {
      dispatch(hideLoader());
    }
  };

  return (
    <Fragment>
      <div style={{ padding: "20px 50px" }}>
        {displaySummary && (
          <Fragment>
            <h5>Summary</h5>
            <PersonalDetailsPreview />
            <KycDetailsPreview />
            <SchemeDetailsPreview />
            <NomineeDetailsPreview />
            <BankDetailsPreview />
            <UploadedDocuments />
            <AmountDetailsSummary />
            <CustomizedDialogs
              open={open}
              closeModal={closeModal}
              copyUrl={copyUrl}
            />
            <CustomizedCopyDialog
              open={openCopy}
              closeModal={() => {
                setOpenCopy(false);
              }}
            />
            <div className="d-flex justify-content-center">
              <button
                className="new-investor-button"
                style={{
                  width: "250px",
                  border: "1px solid #007ac8",
                  color: "#007ac8",
                }}
                onClick={() => {
                  history.push({
                    pathname: "/nps/AddSubs/upload-documents",
                  });
                }}
              >
                Back
              </button>
              <button
                className="new-investor-button new-investor-active"
                onClick={submit}
                style={{ width: "250px" }}
              >
                Confirm
              </button>
            </div>
          </Fragment>
        )}
      </div>
    </Fragment>
  );
};
export default SubscriberSummary;

class CustomizedDialogs extends React.Component {
  render() {
    return (
      <div>
        <Dialog
          onClose={this.props.closeModal}
          aria-labelledby="customized-dialog-title"
          open={this.props.open}
          fullWidth={true}
        >
          <DialogTitle
            id="customized-dialog-title"
            onClose={this.props.closeModal}
          />
          <DialogContent>
            <div className="modal-content-div">
              <Image
                src={"/images/tick.png"}
                style={{ width: 100, height: 100 }}
                alt="tick"
              />
            </div>

            <div>
              <div className="modal-text-container">
                <div className="modal-text">
                  Your investor will receive the confirmation details and
                  verification link via an email and sms
                </div>
              </div>
            </div>
            <div
              style={{
                fontFamily: "OpenSans-SemiBold",
                fontSize: 16,
                textAlign: "center",
              }}
            >
              Would you like to copy the confirmation link ?
            </div>
            <div className="modal-continue-button">
              <div style={{ display: "flex", justifyContent: "center" }}>
                <div className="dual-margin">
                  <Signbutton
                    buttontitle="Copy"
                    onClick={this.props.copyUrl}
                    width={100}
                    padding="10px 30px"
                  />
                </div>
                <div className="dual-margin">
                  <Signbutton
                    buttontitle="Close"
                    onClick={this.props.closeModal}
                    width={100}
                    padding="10px 30px"
                  />
                </div>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}

class CustomizedCopyDialog extends React.Component {
  render() {
    return (
      <div>
        <Dialog
          onClose={this.props.closeModal}
          aria-labelledby="customized-dialog-title"
          open={this.props.open}
          fullWidth={false}
        >
          <DialogTitle
            id="customized-dialog-title"
            onClose={this.props.closeModal}
          />
          <DialogContent>
            <div className="modal-content-div">
              <Image
                src={"/images/tick.png"}
                style={{ width: 100, height: 100 }}
                alt="tick"
              />
            </div>

            <div>
              <div className="modal-text-container">
                <div className="modal-text">URL copied to clipboard</div>
              </div>
            </div>

            <div className="modal-continue-button">
              <div style={{ display: "flex", justifyContent: "center" }}>
                <div className="dual-margin">
                  <Signbutton
                    buttontitle="Okay"
                    onClick={this.props.closeModal}
                    width={100}
                    padding="10px 30px"
                  />
                </div>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}
/* <root>
  <Contribution
    U_Typecode="3"
    U_Branchcode="61821"
    U_UserId="107103"
    Pran_No=""
    AcknowledgementNo="013308a00746801"
    AccountType="1"
    TierType="1"
    ContAmount="1000.00"
    TotalContributionAmount="1000.00"
    ServiceCharge="30.00"
    ServiceTax="41.40"
    TotalPaidAmount="1271.40"
    InsuranceAmount="0.0"
    InsuranceSumAssured="0.0"
    GSTForInsurance="0.0"
    ExcludeInsuranceAmount=""
    ContAmountT2="0.00"
    AggregatorId="BankOfBaroda"
    TypeofContribution="Initial Contribution"
    U_Flag="S"
    InsuranceCPFlag=""
    U_CreatedSource="2"
  />
</root>; */

//created sourece 1

//initial contribution U_Flag = 'I'

//after payment U_Flag = 'P'
